const DEHYDRATE_KEY = 'Dehydrate/Ui'

const NAMESPACE = 'Core'
export const UI_STATE_SET = NAMESPACE + '/UIStateSet'

function componentName(component) {
    var name

    if (typeof component == 'string') {
        name = component
    } else {
        name = component.constructor.displayName
    }

    return name
}

//actions

export function setUIState(component, state) {
    return {
        type: UI_STATE_SET,
        component: componentName(component),
        state: state
    }
}

//reducers

export function uiReducer(state = {}, action) {
    switch (action.type) {
        case UI_STATE_SET:
            return {
                ...state,
                [action.component]: {
                    ...state[action.component],
                    ...action.state
                }
            }
        default:
            return state
    }
}

//actors

function dehydrateUIStateSet() {
    var uiState

    return (state, dispatch) => {
        const nextUiState = state.ui

        if (nextUiState != uiState) {
            localStorage.setItem(DEHYDRATE_KEY, JSON.stringify({
                ui: nextUiState
            }))
            
            uiState = nextUiState
        }
    }
}

export const uiActors = [dehydrateUIStateSet()]

// hydrate

export function hydrate() {
    return JSON.parse(localStorage.getItem(DEHYDRATE_KEY))
}

//helpers

export function uiState(component, ui) {
    return ui[componentName(component)] || {}
}



// WEBPACK FOOTER //
// ./lib/core/redux/ui.js